
















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import ModalContainer from './ModalContainer.vue';
import RequirePasscodeModal from './RequirePasscodeModal.vue';
import WalletCreationModalFlow from '../NewWallet/WalletCreationModalFlow.vue';
import { Mutation, State } from 'vuex-class';

@Component({
  components: {
    ModalContainer,
    RequirePasscodeModal,
    WalletCreationModalFlow,
  },
})
export default class PermissionModal extends Vue {
  @State(profile => profile.user.hasGyriPassphrase, { namespace: 'profile' })
  hasGyriPassphrase!: boolean;

  @Mutation toggleErrorSnackbar!: (payload?: boolean) => void;
  @Mutation updateSnackbarErrorText!: (args: any) => void;

  @Prop(Boolean) showDialog!: boolean;
  @Prop(Function) onClosed!: Function;
  @Prop(Function) action!: Function;
  @Prop(Function) onActionComplete!: Function;
  @Prop(Number) width!: number;

  @Prop(String) requesterName!: string;
  @Prop(String) requesterUri!: string;
  @Prop(String) requestTypeName!: string;
  @Prop(String) allowanceTargetIconUri!: string;
  @Prop(String) allowanceTargetName!: string;
  @Prop(String) permissionDetailIconUri!: string;
  @Prop(String) permissionDetailTextHtml!: string;
  @Prop(String) permissionExplanationLinkUri!: string;
  @Prop(String) permissionExplanationIconType!: string;
  @Prop(String) permissionExplanationLinkText!: string;

  showTransferCodeInput = false;
  showTransferCodeCreation = false;
  actionInProgress = false;

  async onNextClicked() {
    if (this.hasGyriPassphrase) {
      this.showTransferCodeInput = true;
    } else {
      this.showTransferCodeCreation = true;
    }
  }

  async doAction(args: {
    transferCode: string;
    callCompletionCallback: boolean;
  }) {
    this.actionInProgress = true;
    const result = await this.action(args.transferCode);

    if (args.callCompletionCallback) {
      return this.onActionComplete({
        success: true,
        results: result,
        transferCode: args.transferCode,
      });
    } else {
      return result;
    }
  }

  onActionError(err: any) {
    this.toggleErrorSnackbar(true);
    this.updateSnackbarErrorText(err.message);
    console.log(err);
  }
}
